import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jwtAuthAxios from "services/jwtAuth";

export const getPerwalian = createAsyncThunk("perwalian/getPerwalian", async() => {
  let token = localStorage.getItem('auth_token');
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  const response = await jwtAuthAxios.get('/v1/perwalian');
  return response.data;
});

export const getPerwalianId = createAsyncThunk("perwalian/getPerwalianId", async(id) => {
  let token = localStorage.getItem('auth_token');
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  const response = await jwtAuthAxios.get(`/v1/perwalian/${id}`);
  return response.data;
});

export const getPerwalianIdDosen = createAsyncThunk("perwalian/getPerwalianIdDosen", async(id) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`/v1/perwalian/dosen/${id}`);
    return response.data;
});
export const getPerwalianIdMhs = createAsyncThunk("perwalian/getPerwalianIdMhs", async(id) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`/v1/perwalian/mhs/${id}`);
    return response.data;
});
export const getPembimbingAkademikMhs = createAsyncThunk("perwalian/getPembimbingAkademikMhs", async(id) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`/v1/perwalian/mhs/${id}/pembimbing`);
    return response.data;
});

export const getMahasiswaPerwalianPageable = createAsyncThunk(
    "perwalian/getMahasiswaPerwalianPageable",
    async({ page = 0, size = 10, search = '', idProdi = '' } = {}) => {
        let token = localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('size', size);
        if (search) params.append('search', search);
        if (idProdi) params.append('idProdi', idProdi);
        const response = await jwtAuthAxios.get(`/v1/perwalian/mahasiswa/pageable?${params.toString()}`);
        return response.data;
    }
);

export const createPerwalian = createAsyncThunk("kuesioner/createPerwalian", async(payload) => {
  let token = localStorage.getItem('auth_token');
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  const response = await jwtAuthAxios.post('/v1/perwalian', payload);
  return response.data;
});

export const updatePerwalian = createAsyncThunk("kuesioner/updatePerwalian", async(payload) => {
  let token = localStorage.getItem('auth_token');
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  const response = await jwtAuthAxios.put('/v1/perwalian', payload);
  return response.data;
});

export const deletePerwalian = createAsyncThunk("kuesioner/deletePerwalian", async(id) => {
  let token = localStorage.getItem('auth_token');
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  const response = await jwtAuthAxios.delete(`/v1/perwalian/${id}`);
  return response.data;
});

const initialState = {
  loading: false,
  loadingId:false,
  loadingMahasiswaPerwalian: false,
  listPerwalian: [],
  listPerwalianDosen: [],
  listPerwalianId: [],
  mahasiswaPerwalian: {},
    dataDosenWali: {},
    loadingPembimbingAkademik: false,
    pembimbingAkademik: null
}

const perwalianSlice = createSlice({
  name:"perwalian",
  initialState,
  extraReducers: (builder) => {
    builder
        .addCase(getPerwalian.pending, (state) => {
            state.loading = true;
        })
        .addCase(getPerwalian.fulfilled, (state, action) => {
            state.listPerwalian = action.payload;
            state.loading = false;
        })
        .addCase(getPerwalian.rejected, (state, action) => {
            state.loading = false;
            console.error("Error:", action.error);
        })
      builder
        .addCase(getPerwalianId.pending, (state) => {
            state.loadingId = true;
        })
        .addCase(getPerwalianId.fulfilled, (state, action) => {
            state.listPerwalianId = action.payload
            state.loadingId = false;
        })
        .addCase(getPerwalianId.rejected, (state, action) => {
            state.loadingId = false;
            console.error("Error:", action.error);
        })
      builder
        .addCase(getPerwalianIdDosen.pending, (state) => {
            state.loading = true;
        })
        .addCase(getPerwalianIdDosen.fulfilled, (state, action) => {
            state.listPerwalianDosen = action.payload
            state.loading = false;
        })
        .addCase(getPerwalianIdDosen.rejected, (state, action) => {
            state.loading = false;
            console.error("Error:", action.error);
        })
      builder
        .addCase(getMahasiswaPerwalianPageable.pending, (state) => {
            state.loadingMahasiswaPerwalian = true;
        })
        .addCase(getMahasiswaPerwalianPageable.fulfilled, (state, action) => {
            state.mahasiswaPerwalian = action.payload;
            state.loadingMahasiswaPerwalian = false;
        })
        .addCase(getMahasiswaPerwalianPageable.rejected, (state, action) => {
            state.loadingMahasiswaPerwalian = false;
            console.error("Error:", action.error);
        })
      builder
        .addCase(createPerwalian.pending, (state) => {
            state.loading = true;
        })
        .addCase(createPerwalian.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(createPerwalian.rejected, (state, action) => {
            state.loading = false;
            console.error("Error:", action.error);
        })
      builder
        .addCase(updatePerwalian.pending, (state) => {
            state.loading = true;
        })
        .addCase(updatePerwalian.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(updatePerwalian.rejected, (state, action) => {
            state.loading = false;
            console.error("Error:", action.error);
        })
      builder
        .addCase(deletePerwalian.pending, (state) => {
            state.loading = true;
        })
        .addCase(deletePerwalian.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(deletePerwalian.rejected, (state, action) => {
            state.loading = false;
            console.error("Error:", action.error);
        })
      builder
        .addCase(getPerwalianIdMhs.pending, (state) => {
            state.loading = true;
        })
        .addCase(getPerwalianIdMhs.fulfilled, (state, action) => {
            state.dataDosenWali = action.payload
            state.loading = false;
        })
        .addCase(getPerwalianIdMhs.rejected, (state, action) => {
            state.loading = false;
            console.error("Error:", action.error);
        })
      builder
        .addCase(getPembimbingAkademikMhs.pending, (state) => {
            state.loadingPembimbingAkademik = true;
        })
        .addCase(getPembimbingAkademikMhs.fulfilled, (state, action) => {
            state.pembimbingAkademik = action.payload?.data ?? null;
            state.loadingPembimbingAkademik = false;
        })
        .addCase(getPembimbingAkademikMhs.rejected, (state, action) => {
            state.pembimbingAkademik = null;
            state.loadingPembimbingAkademik = false;
            console.error("Error:", action.error);
        })
        
  }
})

export const perwalianSelector = (state) => state.perwalian;
export default perwalianSlice.reducer;

